/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import { LegacyPage } from '@jira/router-routes__common/src/ui/legacy-page/main.tsx';
import type { RouteContext } from '@atlassian/react-resource-router';

type Props = RouteContext;

/**
 * LegacyIssueView is now deprecated, please do not use this.
 * This will soon be removed, ticket to track: https://jplat.jira.atlassian.cloud/browse/JIV-15935
 */
export const LegacyIssueView = (props: Props): React.JSX.Element | null => {
	const { route } = props;

	if (!route) {
		return null;
	}

	return (
		<>
			<LegacyPage {...props} />
		</>
	);
};
